import {arrowRightCircleSvg as Icon__small__arrowRightCircleSvg} from '../Icon__small/Icon__small--arrowRightCircle.js';

export var arrowRightCircle = {
  name: 'arrowRightCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__arrowRightCircleSvg,
};
